"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLottery = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var sign_1 = require("../../model/sign");
var service_1 = require("../../../library/base/service");
var GetLottery = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetLottery, _super);
    function GetLottery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取奖项列表接口';
        _this.code = '101055';
        _this.desc = '获取奖项列表接口';
        _this.requestParams = new sign_1.GetLotteryRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetLottery;
}(service_1.BaseService));
exports.GetLottery = GetLottery;
//# sourceMappingURL=getLottery.js.map